var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.fullscreenEnabled),expression:"fullscreenEnabled"}],staticClass:"flex flex-center preview-fullscreen",on:{"click":_vm.handleToggle}},[_c('Icon',{attrs:{"path":"media","name":"full"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }